// extracted by mini-css-extract-plugin
export default {"item":"dEdJ55","localSwitch":"NseT1V","header":"z1mCzt","mobile":"mzuZzI","services":"JjKhJH"};